/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Book_With_MarkInputs */

const en_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a Lesson With Mark`)
};

const es_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una lección con Mark`)
};

const de_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie eine Unterrichtsstunde bei Mark`)
};

const zh_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与 Mark 一起预订课程`)
};

const ar_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً مع Mark`)
};

const fr_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon avec Mark`)
};

const vi_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học với Mark`)
};

const sw_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya somo na Mark`)
};

const th_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียนกับ Mark`)
};

const bs_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju s Markom`)
};

const ja_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markとレッスンを予約する`)
};

const ko_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark와 레슨 예약하기`)
};

const pt_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula com o Mark`)
};

const it_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione con Mark`)
};

const sv_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion med Mark`)
};

const nl_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les met Mark`)
};

const da_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion med Mark`)
};

const nb_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en leksjon med Mark`)
};

const fi_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti Markin kanssa`)
};

const pl_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję z Markiem`)
};

const ru_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на урок к тренеру Mark`)
};

const tr_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark ile ders ayırtın`)
};

const hi_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark के साथ एक सबक बुक करें`)
};

const id_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran dengan Mark`)
};

const ms_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran bersama Mark`)
};

const cs_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte si lekci s Markem`)
};

const el_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα με τον Mark`)
};

const he_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו שיעור עם Mark`)
};

const af_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n les by Mark`)
};

const hu_about_book_with_mark = /** @type {(inputs: About_Book_With_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalj egy leckét Markkal`)
};

/**
* | output |
* | --- |
* | "Book a Lesson With Mark" |
*
* @param {About_Book_With_MarkInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_book_with_mark = /** @type {((inputs?: About_Book_With_MarkInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Book_With_MarkInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_book_with_mark(inputs)
	if (locale === "de") return de_about_book_with_mark(inputs)
	if (locale === "zh") return zh_about_book_with_mark(inputs)
	if (locale === "ar") return ar_about_book_with_mark(inputs)
	if (locale === "fr") return fr_about_book_with_mark(inputs)
	if (locale === "vi") return vi_about_book_with_mark(inputs)
	if (locale === "sw") return sw_about_book_with_mark(inputs)
	if (locale === "th") return th_about_book_with_mark(inputs)
	if (locale === "bs") return bs_about_book_with_mark(inputs)
	if (locale === "ja") return ja_about_book_with_mark(inputs)
	if (locale === "ko") return ko_about_book_with_mark(inputs)
	if (locale === "pt") return pt_about_book_with_mark(inputs)
	if (locale === "it") return it_about_book_with_mark(inputs)
	if (locale === "sv") return sv_about_book_with_mark(inputs)
	if (locale === "nl") return nl_about_book_with_mark(inputs)
	if (locale === "da") return da_about_book_with_mark(inputs)
	if (locale === "nb") return nb_about_book_with_mark(inputs)
	if (locale === "fi") return fi_about_book_with_mark(inputs)
	if (locale === "pl") return pl_about_book_with_mark(inputs)
	if (locale === "ru") return ru_about_book_with_mark(inputs)
	if (locale === "tr") return tr_about_book_with_mark(inputs)
	if (locale === "hi") return hi_about_book_with_mark(inputs)
	if (locale === "id") return id_about_book_with_mark(inputs)
	if (locale === "ms") return ms_about_book_with_mark(inputs)
	if (locale === "cs") return cs_about_book_with_mark(inputs)
	if (locale === "el") return el_about_book_with_mark(inputs)
	if (locale === "he") return he_about_book_with_mark(inputs)
	if (locale === "af") return af_about_book_with_mark(inputs)
	if (locale === "hu") return hu_about_book_with_mark(inputs)
	return en_about_book_with_mark(inputs)
});